import axios from "axios";
import { useEffect, useState } from "react";
import Gugun from "./Gugun";
import { Link, Route, Routes } from "react-router-dom";
import Itm from "./Itm";
import AllList from "./AllList";

import './reset.scss';
import './common.scss';

const App = () => {
    const [data, setData] = useState([]);
    const [gugunName, setGugunName] = useState([]);

    const getData = async () => {
        const r = await axios.get('https://apis.data.go.kr/6260000/FoodService/getFoodKr?serviceKey=%2FEByVU0%2BhD7q%2B5CoWC%2B%2FSu0lPhlm7zk3%2FiUX4Feo%2BgCAZ0WQ%2BbSWpbFvhQjr%2FQTWCni%2FdT8V4vdgwEn9bsU6nA%3D%3D&pageNo=1&numOfRows=260&resultType=json')
        // console.log(r.data.getFoodKr.item[0].GUGUN_NM);
        setData(r.data.getFoodKr.item);
        const GG = r.data.getFoodKr.item.map(it => it.GUGUN_NM);
        const GG_LIST = [...new Set(GG)];
        console.log(GG_LIST);
        setGugunName(GG_LIST);
    }


    useEffect(() => {
        getData();
    }, [])

    return (
        <div>
            <h1><Link to={`/`}>부산 맛집</Link></h1>
            <hr />
            <nav className='gnb'>
                <ul>
                    {
                        gugunName.map(it => {
                            return (
                                <li><Link to={`/gu/${it}`}>{it}</Link></li>
                            )
                        })
                    }
                </ul>
            </nav>


            <Routes>
                <Route path="/" element={<AllList data={data} />} />
                <Route path="/gu/:gugun" element={<Gugun data={data} />} />
                <Route path="/:itm" element={<Itm data={data} />} />
            </Routes>




        </div>
    )
}

export default App;